// Plain passthrough wrapper. Kept as a component so pages can opt into
// entrance motion later without touching markup; visibility never depends on it.
export const Reveal = ({ children, className = "" }) => (
  <div className={className}>{children}</div>
);
